import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
class PopupContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount(){

  }
  componentWillUnmount(){
  }

  render () {
    return (
      <React.Fragment>
      <ToastContainer
        position="top-right"
        autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange={false}
        draggable={false}
        />

      </React.Fragment>
    );
  }
}

export default PopupContainer
